export default __webpack_public_path__ + "static/boyan_mihaylov-c1846d0bff22b9e2131f04aac136c04a.jpg";